import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=cf8618d8&"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports